module.exports = __webpack_public_path__ + "img/icon.5a60ee9.png";